export default "__VITE_ASSET__DED6tJcG__"